module.exports = __webpack_public_path__ + "static/media/dipak ambhure.c9b3e6fd.jpg";